import { KeyValue } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContextAdmin } from 'app/_models/admin/context.admin';
import { SettingsBase } from 'app/_models/admin/settings/settings.base';
import { ConfigData } from 'app/_models/common/config.data';
import { AdminSettingsService } from 'app/_services/admin/admin-settings.service';
import { AdminService } from 'app/_services/admin/admin.service';
import { ApiService } from 'app/_services/api.service';
import { MainService } from 'app/_services/main.service';
import { ToasterService } from 'app/_services/toaster.service';

@Component({
  selector: 'app-service-management',
  templateUrl: './service-management.component.html',
  styleUrl: './service-management.component.scss'
})
export class ServiceManagementComponent {
  ctx: ContextAdmin;
  settings: SettingsBase;
  services: { [key: string]: { [key: string]: string } };
  responses: { [key: string]: string } = {};


  constructor(
    public adminSettingsService: AdminSettingsService,
    public adminService: AdminService,
    public mainService: MainService,
    private toasterService: ToasterService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.data
      .subscribe((data: any) => {
        this.settings = data.settings;
        this.services = this.adminSettingsService.getAdminSetting(this.settings, 'ApiServices').Value;
      });
    this.adminService.getContext()
      .subscribe((ctx: ContextAdmin) => {
        this.ctx = ctx;
      });
  }

  reloadApiService(api: KeyValue<string, string>) {
    this.responses[api.key] = 'busy';
    this.adminService.reloadApiService(api.value)
      .subscribe((response) => {

        if (response.Success) {
          this.toasterService.showToast('Succes', `De service ${api.key} is succesvol herladen.`);
          this.responses[api.key] = '';
        } else {
          this.responses[api.key] = response.Message;
          this.toasterService.showToast('Helaas', `Er is een fout opgetreden bij het herladen van de service ${api.key}.\nFoutmelding: ${response.Message}`);
        }
      }, (error) => {
        this.responses[api.key] = `Er is een fout opgetreden bij het herladen van de service ${api.key}.`;
        this.toasterService.showToast('Helaas', `Er is een fout opgetreden bij het herladen van de service ${api.key}.`);
      });
  }


}
